var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonicGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#3880FF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.43537415,0,0,0.43537415,-16.631293,-79.368707)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44bba4"
    },
    id: "path4",
    d: "m 111.8,222.5 c -18.5,0 -33.5,15 -33.5,33.5 0,18.5 15,33.5 33.5,33.5 18.5,0 33.5,-15 33.5,-33.5 -0.1,-18.5 -15.1,-33.5 -33.5,-33.5 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#44bba4"
    },
    id: "circle6",
    r: 15.3,
    cy: 210.2,
    cx: 159.8,
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44bba4"
    },
    id: "path10",
    d: "m 178.6,225.5 -0.6,-1.4 -1,1.2 c -2.5,2.8 -5.7,5 -9.2,6.3 l -1,0.4 0.4,1 c 3.1,7.3 4.6,15.1 4.6,23 0,33.1 -26.9,60.1 -60.1,60.1 -33.2,0 -60,-27 -60,-60.1 0,-33.1 26.9,-60.1 60.1,-60.1 9,0 17.6,2 25.7,5.8 l 0.9,0.4 0.4,-1 c 1.5,-3.5 3.8,-6.5 6.8,-8.9 l 1.2,-1 -1.4,-0.7 c -10.5,-5.4 -21.8,-8.2 -33.7,-8.2 -40.5,0 -73.5,33 -73.5,73.5 0,40.5 33,73.5 73.5,73.5 40.5,0 73.5,-33 73.5,-73.5 0,-10.4 -2.2,-20.6 -6.6,-30.3 z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicGreen);
export default __webpack_public_path__ + "static/media/ionic-green.867f7e14a1a35931b8a9e499e28349ec.svg";
export { ForwardRef as ReactComponent };